{
    "Routes":{
        "populatedropdown": "populatedropdown?dropdownName=",
        "docsearch": "search",
        "docbyid": "getdocument"
    },
    "headerConfig":{
        "headers":{
           "Access-Control-Allow-Origin" : "*"
        }
    },
    "identityServer": {
        "request": {
            "client_id": "inode-client",
            "client_secret": "INodeSecretKey",
            "scope": "prostewardservices",
            "grant_type": "client_credentials"
        }
    }
}